import styled from 'styled-components';

export const Actions = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;
